import { useEffect, useState } from 'react'
import React from 'react'
import AOS from 'aos';
import deville1 from '../Assets/deville1.webp';
import deville2 from '../Assets/deville2.webp';
import mascot from '../Assets/mascot.webp';
import blob2 from '../Assets/blob2.webp';

export default function Aboutsoc(){
    useEffect(() => {
        /**
         * Server-side rendering does not provide the 'document' object
         * therefore this import is required either in useEffect or componentDidMount as they
         * are exclusively executed on a client
         */
        const AOS = require("aos");
        AOS.init({
          once: true,
        });
      }, []);
    
    useEffect(() => {
        if (AOS) {
          AOS.refresh();
        }
      });
    
    return(
        <div className="overflow-visible mt-20 lg:mt-48">
            <h1 className="font-[BebasNeue] text-white/80 text-5xl lg:text-8xl lg:ml-48 ml-16"
             data-aos="fade-right"
             data-aos-offset="300"
             data-aos-duration="1000"
             data-aos-delay="0"
            >ABOUT SOC</h1>
            <h1 className="font-[BebasNeue] text-white/50 text-5xl lg:text-8xl -mt-2 ml-8 lg:ml-32"
             data-aos="fade-right"
             data-aos-offset="300"
             data-aos-duration="1000"
             data-aos-delay="0"
            >ABOUT SOC</h1>
            <div className="mx-16 lg:w-[40rem] lg:ml-[28rem] lg:-mt-24"
             data-aos="fade-left"
             data-aos-offset="300"
             data-aos-duration="1000"
             data-aos-delay="0">
                <img src={deville2} className="rounded-md lg:rounded-lg lg:w-full"/>
            </div>
            <div className="grid grid-cols-2 mx-16">
                <div className="border border-white rounded-lg lg:rounded-xl text-white px-3 py-3 lg:px-5 lg:py-5 backdrop-blur-lg bg-slate-100 bg-opacity-20 text-left leading-5 w-[17rem] lg:w-[29rem] -mt-8 -ml-8 lg:ml-16 text-xs h-fit lg:text-base font-[JakartaSansBold] lg:-mt-64"
                 data-aos="fade-right"
                 data-aos-offset="300"
                 data-aos-duration="1000"
                 data-aos-delay="0">
                SMAKONECUP 2023 merupakan salah satu acara terbesar dalam serangkaian program satu tahun kami. Acara ini merupakan event persahabatan antar sekolah yang memperlombakan 16 cabang lomba baik dalam bidang akademis maupun non akademis.<span className="hidden lg:block"> Dengan diadakannya SMAKONECUP 2023, diharapkan tujuan pengembangan potensi generasi muda secara menyeluruh dapat tercapai.</span></div>
                <img src={mascot} className="h-64 lg:h-[40rem] lg:-mt-[30rem] lg:ml-32 -mt-32 ml-16 lg:z-10"
                 data-aos="fade-left"
                 data-aos-offset="300"
                 data-aos-duration="1000"
                 data-aos-delay="0"/>
                <img src={blob2} className="z-10 absolute -mt-6 overflow-clip lg:ml-[39rem]"/>  
            </div> 
             <div className="mx-16 lg:w-[40rem] lg:ml-[13rem] lg:-mt-72">
                <img src={deville1} className="rounded-md mt-2 lf:w-full"
                 data-aos="fade-right"
                 data-aos-offset="300"
                 data-aos-duration="1000"
                 data-aos-delay="0"/>
            </div>
            <div className="border border-white rounded-lg lg:rounded-xl text-white px-3 py-3 lg:px-5 lg:py-5 backdrop-blur-lg bg-slate-100 bg-opacity-20 text-left leading-5 w-[17rem] lg:w-[29rem] -mt-16 ml-24 lg:ml-[35rem] lg:-mt-18 text-xs lg:text-base font-[JakartaSansBold]"
             data-aos="fade-left"
             data-aos-offset="100"
             data-aos-duration="1000"
             data-aos-delay="0">
              <span className="lg:hidden">Dengan diadakannya SMAKONECUP 2023, diharapkan tujuan pengembangan potensi generasi muda secara menyeluruh dapat tercapai.</span> Generasi muda dapat mengembangkan secara luas dan mendalam kemampuan dan potensi yang dimiliki dan mengekspresikannya melalui acara ini.
            </div>
        </div>  
    )
}

